import { render, staticRenderFns } from "./CatastroUD.vue?vue&type=template&id=36ca3c24&scoped=true"
import script from "./CatastroUD.vue?vue&type=script&lang=js"
export * from "./CatastroUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca3c24",
  null
  
)

export default component.exports